module.exports = __webpack_public_path__ + "img/produit_frais.c58d0ea9.png";